import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { breakpoints, styleVariables } from '../style';
import { colors, sizes } from '../style-foundation';
import { useResponsive } from './use-responsive.hook';
//=================================================
export var useTheme = function useTheme() {
  var media = useResponsive(breakpoints);

  var theme = _objectSpread(_objectSpread({
    useColorSchemeMediaQuery: false
  }, styleVariables), {}, {
    media: media,
    defaultMode: 'light',
    color: _objectSpread({}, styleVariables.colors.light),
    fontSizes: _objectSpread(_objectSpread({}, styleVariables.fontSizes), styleVariables.font),
    breakpoints: styleVariables.breakpoints,
    //===========================================
    colors: _objectSpread(_objectSpread({}, colors.light), {}, {
      modes: {
        dark: colors.dark
      }
    }),
    sizes: sizes
  });

  return {
    theme: theme
  };
};
export var getColor = function getColor(color) {
  return function (_ref) {
    var _theme$colors;

    var theme = _ref.theme;
    return (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors[color];
  };
};
export var getSize = function getSize(size) {
  return function (_ref2) {
    var _theme$sizes;

    var theme = _ref2.theme;
    return (_theme$sizes = theme.sizes) === null || _theme$sizes === void 0 ? void 0 : _theme$sizes[size];
  };
};